export const MORNING_WORKING_TIME = {
    START: "08:30",
    END: "12:00"
};

export const AFTERNOON_WORKING_TIME = {
    START: "13:00",
    END: "17:30"
};

export enum CONFIG_BY_WEEK_OPTIONS  {
    FROM_MONDAY_TO_SATURDAY = 'from-monday-to-saturday',
    FROM_MONDAY_TO_FRIDAY_SATURDAY_SUNDAY_OFF = 'from-monday-to-friday-saturday-and-sunday-off',
    FROM_MONDAY_TO_FRIDAY_WORK_SATURDAY_EVERY_OTHER_WEEK = 'from-monday-to-friday-work-saturday-every-other-week',
}